import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SafeHtml, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FundrecommService } from 'src/app/services/fundrecomm.service';
import 'dotdotdot-js'
@Component({
  selector: 'app-vdo-detail',
  templateUrl: './vdo-detail.component.html',
  styleUrls: ['./vdo-detail.component.scss']
})
export class VdoDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: FundrecommService,
    private _sanitizer: DomSanitizer) { }
  language = JSON.parse(localStorage.getItem('language'))
  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';

  id: any = "";
  private player;
  private ytEvent;

  vdo: any;
  showvdo: any;
  detail: any;
  file_pdf: string;
  vdoTitle: string;
  vdoType: string;
  vdoDate: string;
  pdfUrl_path: any;
  pdfUrl: any;
  videoSource: any;
  filesize: any;

  flag: any

  ngOnInit() {

    this.flag = localStorage.getItem("language_flag")

    this.vdo = this.route.params.subscribe(params => {
      this._mainService.get_vdoById(params['id']).subscribe(response => {
        
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].vdo_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail = this.htmlTransforms(response[0].detail);
            this.detail = this.htmlTransforms(response[0].detail);

            this.showvdo = response;
            this.vdoTitle = response[0].title;
            this.vdoType = response[0].vdo_type;
            this.vdoDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].vdo_type === 'image') {
            this.file_pdf = 'no';
            this.showvdo = response;
            this.detail = response[0].detail;
            this.vdoTitle = response[0].title;
            this.vdoType = response[0].vdo_type;
            this.vdoDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].vdo_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail;
            this.showvdo = response;
            this.pdfUrl = this.urlTransform(response[0].detail);
            this.vdoTitle = response[0].title;
            this.vdoType = response[0].vdo_type;
            this.filesize = response[0].filesize
            this.vdoDate = this._mainService.date_thai(response[0].publicDate);

          }
          else if (response[0].vdo_type === 'vdo') {
            this.file_pdf = 'no';
            this.showvdo = response;
            this.detail = response[0].detail;
            this.id = response[0].detail;
            this.vdoTitle = response[0].title;
            this.vdoType = response[0].vdo_type;
            this.vdoDate = this._mainService.date_thai(response[0].publicDate);

          }
        } else {
          if (response[0].vdo_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail_en = this.htmlTransforms(response[0].detail_en);
            this.detail = this.htmlTransforms(response[0].detail_en);

            this.showvdo = response;
            this.vdoTitle = response[0].title_en;
            this.vdoType = response[0].vdo_type;
            this.vdoDate = response[0].publicDate;

          } else if (response[0].vdo_type === 'image') {
            this.file_pdf = 'no';
            this.showvdo = response;
            this.detail = response[0].detail_en;
            this.vdoTitle = response[0].title_en;
            this.vdoType = response[0].vdo_type;
            this.vdoDate = response[0].publicDate;

          } else if (response[0].vdo_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail_en;
            this.showvdo = response;
            this.pdfUrl = this.urlTransform(response[0].detail_en);
            this.vdoTitle = response[0].title_en;
            this.vdoType = response[0].vdo_type;
            this.filesize = response[0].filesize
            this.vdoDate = response[0].publicDate;

          }
          else if (response[0].vdo_type === 'vdo') {
            this.file_pdf = 'no';
            this.showvdo = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.vdoTitle = response[0].title_en;
            this.vdoType = response[0].vdo_type;
            this.vdoDate = response[0].publicDate;

          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.vdo.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }

  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
}